<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h3>
        <i class="fa-solid fa-users me-2"></i>
        <ng-container *ngIf="viewMode === ViewMode.INSERT">Benutzer anlegen</ng-container>
        <ng-container *ngIf="viewMode === ViewMode.EDIT">Benutzer bearbeiten</ng-container>
        <ng-container *ngIf="viewMode === ViewMode.VIEW">Benutzer</ng-container>
    </h3>
</div>

<form [formGroup]="form">
    <div class="row">
        <div class="col">
            <label>Name</label>
            <input class="form-control" typeaheadOptionField="displayName"
                   formControlName="_userSearch"
                   *ngIf="viewMode === ViewMode.INSERT"
                   [typeahead]="users$"
                   [typeaheadAsync]="true"
                   [typeaheadMinLength]="4"
                   [typeaheadWaitMs]="1000"
                   (typeaheadOnSelect)="onSelectUser($event)"
                   (typeaheadNoResults)="typeaheadUsersNoResults($event)"
                   (typeaheadLoading)="typeaheadUsersLoading($event)"
                   autocomplete="off"
                   placeholder="Bitte Benutzer suchen">

            <span *ngIf="loading"><i class="fa fa-spinner fa-pulse fa-2x mt-2"></i></span>

            <p *ngIf="noUserResult" class="bg-warning px-2 py-1 mt-2">Keine Benutzer gefunden</p>
            <p *ngIf="viewMode !== ViewMode.INSERT">{{ form.value.name }}</p>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <label>Kürzel</label>
            <input type="text" class="form-control" formControlName="short" *ngIf="viewMode !== ViewMode.VIEW">
            <p *ngIf="viewMode === ViewMode.VIEW">{{ form.value.short }}</p>
        </div>
        <div class="col" *ngIf="viewMode !== ViewMode.INSERT">
            <label>E-Mail</label>
            <p>
                {{ form.value.email }}
                <span class="text-muted" *ngIf="!form.value.email">Nicht gesetzt</span>
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col" *ngIf="viewMode !== ViewMode.INSERT">
            <label>Letzter Login</label>
            <p>
                {{ form.value.last_login | date: 'dd.MM.yyyy, HH:mm' }}
                <span class="text-muted" *ngIf="!form.value.last_login">Noch nicht eingeloggt</span>
            </p>
        </div>
        <div class="col">
            <label class="form-label">Aktiv</label>
            <div *ngIf="viewMode !== ViewMode.VIEW">
                <input type="checkbox" class="form-check-input" formControlName="active">
            </div>
            <p class="gray" *ngIf="viewMode === ViewMode.VIEW">{{ form.value.active | yesNo }}</p>
        </div>
    </div>

    <div>
        <label class="form-label">Rollen</label>
        <select class="form-control" formControlName="roles" size="3" multiple *ngIf="viewMode !== ViewMode.VIEW">
            <option value="" disabled selected style="display: none;">Bitte auswählen</option>
            <option value="orderer">Projektauftraggeber</option>
            <option value="lead">Projektleiter</option>
            <option value="customer">Projektkunde</option>
        </select>
        <p *ngIf="viewMode !== ViewMode.VIEW">
            <small class="text-muted">
                Mehrfachauswahl und Abwahl mit STRG+Linksklick.
            </small>
        </p>
        <ng-container *ngIf="viewMode === ViewMode.VIEW">
            <ul class="gray list-inline roles" *ngIf="form.value.roles?.length > 0">
                <li class="list-inline-item me-0" *ngFor="let role of form.value.roles">{{ role | teamRole }}</li>
            </ul>

            <p class="text-muted mb-2" *ngIf="form.value.roles?.length === 0">Keine Rollen vergeben</p>
        </ng-container>
    </div>
</form>

<label class="form-label">Rechte</label>
<table class="table table-sm table-rights">
    <thead>
    <tr>
        <th>Name</th>
        <th>Gesetzt</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let right of rights">
        <td>{{right.name}}</td>
        <td style="width: 100px">
            <input type="checkbox" *ngIf="viewMode !== ViewMode.VIEW" [(ngModel)]="right.granted">
            <div class="gray" *ngIf="viewMode === ViewMode.VIEW">
                <i class="fa-solid fa-check text-success" *ngIf="right.granted"></i>
                <i class="fa-solid fa-times text-danger" *ngIf="!right.granted"></i>
                {{ right.granted | yesNo }}
            </div>
        </td>
    </tr>
    </tbody>
</table>
<ng-container *ngIf="viewMode !== ViewMode.VIEW">
    <button type="button" class="btn btn-secondary btn-sm float-end" (click)="toggleRights(true)">Alle</button>
    <button type="button" class="btn btn-secondary btn-sm float-end me-2" (click)="toggleRights(false)">Keine</button>
    <div class="clearfix"></div>
</ng-container>

<div style="border-top: 1px solid #dee2e6" class="mt-3 py-3">
    <ng-container *ngIf="viewMode === ViewMode.VIEW">
        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
    </ng-container>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>

    <ng-container *ngIf="viewMode === ViewMode.INSERT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="save()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
    </ng-container>
</div>
